import { computed, ref, watch } from 'vue';
import { stage } from '@/views/MediaEditorView/SlideEditor/Stage/baseElementsRefs';

export const stageScale = ref(1);
export const stageScaleConfig = computed(() => {return {x: stageScale.value, y: stageScale.value}});
// export const stagePosition = ref({ x: 0, y: 0 });
export const stagePosition = ref({ x: 150, y: 150 });

export const stageWidth = ref(0);
export const stageHeight = ref(0);